import { useMemo, useState } from 'react';

import { BasicModal } from '../../../../../components/modal';
import { useForm } from '../../../../../hooks';
import { IuseForm } from '../../../../../hooks/useForm';
import { TEXT_CONTENT } from '../../../../../utils/constants';
import { DAY_DROP_DOWN_OPTIONS } from '../../../../../utils/date';
import {
  GRAPH_GENERATE_STATUS,
  SHIFT_MANAGE_STATUS,
  useFacilityContext,
} from '../../../contexts/FacilityProvider';
import { FacilitySnapShot } from '../../../contexts/FacilityProvider.types';
import { ShiftProviderState } from '../../../contexts/ShiftProvider.types';
import ShiftController from './ShiftController';
import { ForcedShiftControllerModalProps } from './ShiftControllerModal.types';

export default function ForcedShiftControllerModal({
  open,
  onClose = () => {},
  sx = {},
  onUpdate = () => {},
  shiftData = {},
  ...rest
}: ForcedShiftControllerModalProps) {
  const {
    state: { selectedFacility, facilitySnapshots },
  } = useFacilityContext();
  // const {
  //   state: {
  //     scenarios: { selected: selectedScenario },
  //   },
  // } = useDashboardContext();

  const [shiftControllerSelectedDay, setshiftControllerSelectedDay] =
    useState('');

  // const { data: forcedShifts, isLoading } = useApiData(
  //   END_POINTS.SOT.forcedShifts(selectedFacility),
  //   {
  //     params: {
  //       client_id: undefined,
  //     },
  //   } //client_id
  // );

  const form = useForm({}, {}, onUpdate);
  const { isFormValid, formData, reset } = form;

  const activeFacilitySnapShot: FacilitySnapShot = {
    userGraphGenerationStatus: GRAPH_GENERATE_STATUS.IDLE_GENERATED_GRAPH,
    userShiftManageStatus: SHIFT_MANAGE_STATUS.IDLE,
    clientId: undefined,
    ...(facilitySnapshots?.[selectedFacility] || {}),
  };

  const [prevShiftData, setPrevShiftData] =
    useState<ShiftProviderState['shifts']['data']>();
  const patchShiftData = (data: ShiftProviderState['shifts']['data']) => {
    const newShiftData: IuseForm['formData'] = { ...data };
    Object.values(data).forEach((d) => {
      newShiftData[d.id] = { ...d, baseStartDate: d.startDate };
    });
    reset(newShiftData);
  };
  if (JSON.stringify(prevShiftData) !== JSON.stringify(shiftData)) {
    setPrevShiftData(shiftData);
    patchShiftData(shiftData);
  }
  const isShiftChanged = useMemo(
    () =>
      Object.values(formData).some((d) =>
        ['new', 'update', 'delete'].includes(d?.status || '')
      ),
    [formData]
  );
  const isSubmitDisabled =
    activeFacilitySnapShot?.userShiftManageStatus ===
      SHIFT_MANAGE_STATUS.IN_PROGRESS ||
    !isFormValid ||
    !isShiftChanged;
  const isUpdating =
    activeFacilitySnapShot?.userShiftManageStatus ===
    SHIFT_MANAGE_STATUS.IN_PROGRESS;

  const handleDaySelect = (v: string) => {
    setshiftControllerSelectedDay(v);
  };
  return (
    <BasicModal open={open} onClose={onClose} sx={{ ...sx }} {...rest}>
      <ShiftController
        title={TEXT_CONTENT.EDIT_FORCED_SHIFT_TIMES}
        form={form}
        isUpdating={isUpdating}
        isSubmitDisabled={isSubmitDisabled}
        onCancel={onClose}
        onDaySelect={handleDaySelect}
        weekDaysList={DAY_DROP_DOWN_OPTIONS}
        selectedStartDay={shiftControllerSelectedDay}
        // isLoading={isLoading}
      />
    </BasicModal>
  );
}
